//social media
import {Mail, PhoneCall, Instagram} from "react-feather";
import eitaaIcon from '@assets/images/icons/eitaa.png';
import soroushIcon from '@assets/images/icons/soroush.png';

export const DETAILS = {
    "name": "  فریور حساب",
    "enName": "Farivar Hesab ",
    "description": "",
    "mobile": [],
    "phones": [
        '02634316422 ',
        '09120208463',
        '09372639959',
        '09126592067',
    ],
    "email": [],
    "postalCode": [""],
    address: "تهران - خیابان سعدی جنوبی - رو به روی کوچه ترابی گودرزی - ساختمان نمازی - پلاک۲۹۹ - واحد۶",
    mapIframeSrc: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d810.3309521343022!2d51.363886269646315!3d35.66902808779905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDQwJzA4LjUiTiA1McKwMjEnNTIuMyJF!5e0!3m2!1sen!2sus!4v1693816137269!5m2!1sen!2sus",
    socialMedia: [
        {
            title: 'واتس اپ',
            value: '09125342338',
            name: 'whatsapp',
            link: 'https://api.whatsapp.com/send/?phone=+9125342338&text&app_absent=0',
            icon: <i className="lab la-whatsapp"/>,
            isPrimary: true
        },
        // {
        //     title: 'تلگرام',
        //     value: '09123456789',
        //     name: 'telegram',
        //     link: 'https://t.me/+9123456789',
        //     icon: <i className="lab la-telegram-plane"/>,
        //     isPrimary: true
        // },
        // {
        //     title: 'اینستاگرام',
        //     value: 'user',
        //     name: 'instagram',
        //     link: 'https://www.instagram.com/user/',
        //     icon: <i className="lab la-instagram"/>,
        //     isPrimary: true
        // },
        // {
        //     title: 'ایمیل',
        //     value: 'Volvotak@gmail.com',
        //     name: 'email',
        //     link: 'mailto:Volvotak@gmail.com',
        //     icon: <i className="las la-envelope"></i>,
        //     isPrimary: true
        // },
        // {
        //     title: 'تماس',
        //     value: '09133377432',
        //     name: 'phone',
        //     link: 'tel:989133377432',
        //     icon: <PhoneCall/>,
        //     isPrimary: true
        // },
        /*{
            title: 'آپارات',
            value: 'Alo_aghsat',
            name: 'aparat',
            link: 'https://www.aparat.com/Alo_aghsat',
            icon: <SiAparat size={25}/>,
            isPrimary: true
        },
        {
            title: 'تماس',
            value: '02636634893',
            name: 'phone',
            link: 'tel:+982636634893',
            icon: <PhoneCall/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09331074475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09332094475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09330324475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },
        {
            title: 'ایتا',
            value: '09331074475',
            name: 'eitaa',
            link: '',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        },
        {
            title: 'ایتا',
            value: '09332094475',
            name: 'eitaa',
            link: '',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        },
        {
            title: 'ایتا',
            value: '09330324475',
            name: 'eitaa',
            link: '',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        }*/
    ],
    services: [],
    brands: [
        /*{
            name: 'Apple',
            image: <img src={appleImage} alt='apple'/>,
        },*/
    ],
    relatedLinks: [
        /* {
             title: 'بانک ملت',
             link: 'https://bankmellat.ir/',
             icon: <img src={MellatBankImage} alt='mellat-bank'/>,
         */
    ],
    "supportDescription": "",
    "workingHours": [],
    "__choose among these__": "",
    "enamadLink": true,
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}
